import * as tslib_1 from "tslib";
import { InputDateTimeComponent } from '../input-datetime/input-datetime.component';
import createAutoCorrectedDateTimePipe from '../../pipes/create-datetime.pipe';
import { LocalisationService } from '../../../core/localisation.service';
/**
 * Class for the time input component
 */
var InputTimeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputTimeComponent, _super);
    function InputTimeComponent(localisationService) {
        var _this = _super.call(this, localisationService) || this;
        _this.allowedStates = ['hours', 'minutes'];
        _this.initialState = 'hours';
        _this.placeholderKey = 'APP.INPUTS.TIME_PLACEHOLDER';
        return _this;
    }
    Object.defineProperty(InputTimeComponent.prototype, "formatString", {
        get: function () {
            return this.localisationService.time.format;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputTimeComponent.prototype, "pipe", {
        get: function () {
            return createAutoCorrectedDateTimePipe(this.localisationService.time.correctionFormat);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputTimeComponent.prototype, "mask", {
        get: function () {
            return LocalisationService.toMaskArray(this.localisationService.time.mask);
        },
        enumerable: true,
        configurable: true
    });
    return InputTimeComponent;
}(InputDateTimeComponent));
export { InputTimeComponent };
